import { view } from "@risingstack/react-easy-state";
import { IconBoil } from "@tine/designsystem-icons/sharp";
import { Stack } from "@tine/designsystem-ui-react";
import { cn } from "@tine/designsystem-utils";
import { GA_NAVIGATION_MAIN_CATEGORY } from "../../common/tracking";
import type { CategoryInfo } from "../../common/types/categoryTypes";
import { titleCase } from "../../common/utils";
import productStore from "../../stores/product/productStore";
import { InternalLink } from "../Links";

type CategoryNavigationVerticalProps = {
   categoryInfo: CategoryInfo;
   currentCategoryId?: string;
   className?: string;
   includeAll?: boolean;
};

const CategoryNavigationVertical = ({
   categoryInfo,
   currentCategoryId = "",
   className = "",
   includeAll = false
}: CategoryNavigationVerticalProps) => {
   const totalAssortmentProducts = (skus: string[]) => productStore.resolveSkus(skus, true).length;

   const linkStyle = (ci: CategoryInfo) => {
      const isCurrent = (currentCategoryId && ci.id === currentCategoryId) || (!currentCategoryId && ci.url_key === "produkter");
      return cn("tw-no-underline", { "tw-font-bold": isCurrent }, { "hover:tw-underline": !isCurrent });
   };

   return (
      <Stack className={className} align="start" justify="start" gap={1} wrap="nowrap" grow={false}>
         {includeAll && (
            <InternalLink
               href={categoryInfo.fullUrl}
               className={linkStyle(categoryInfo)}
               trackingLocationName={GA_NAVIGATION_MAIN_CATEGORY}
            >
               <div>Alle produkter</div>
            </InternalLink>
         )}
         {categoryInfo.children.map((child) => {
            const productCount = totalAssortmentProducts(child.skus);
            return productCount > 0 ? (
               <InternalLink
                  key={child.id}
                  href={child.fullUrl}
                  className={linkStyle(child)}
                  trackingLocationName={GA_NAVIGATION_MAIN_CATEGORY}
                  linkName={child.name}
               >
                  <div>
                     {child.catId === "produkter/nyheter" ? (
                        <IconBoil className="tw-inline tw-ml-[-4px] tw-size-5 tw-pb-1" />
                     ) : (
                        ""
                     )}
                     {`${titleCase(child.name)}`}
                  </div>
               </InternalLink>
            ) : null;
         })}
      </Stack>
   );
};

export default view(CategoryNavigationVertical);
